<form *ngIf="!!heroEventForm && !isLoading" [formGroup]="heroEventForm">
  <div class="twoColumnLayout">
    <div class="column">
      <mat-card>
        <mat-card-header>
          <mat-card-title>EVENT INFORMATION</mat-card-title>
        </mat-card-header>
      <mat-card-content>
        <mat-form-field class="full-width-input">
          <mat-label>Name</mat-label>
          <input formControlName="name" matInput type="text" />
          <app-error-display
            [form]="heroEventForm"
            controlName="name"></app-error-display>
        </mat-form-field>
        <mat-form-field class="full-width-input">
          <mat-label>Category</mat-label>
          <input type="text" matInput formControlName="eventCategoryId" [matAutocomplete]="auto">
          <mat-icon matSuffix class="icon" *ngIf="!heroEventForm.get('eventCategoryId').value">arrow_drop_down</mat-icon>
          <button
            matSuffix
            class="icon"
            *ngIf="heroEventForm.get('eventCategoryId').value"
            mat-icon-button
            aria-label="Clear"
            (click)="onClear('eventCategoryId')"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displaySelectedCategory.bind(this)" showPanel="true">
            <mat-option *ngFor="let option of filteredCategoryOptions | async" [value]="option.value">
              {{option.display}}
            </mat-option>
          </mat-autocomplete>
          <app-error-display
            [form]="heroEventForm"
            controlName="eventCategoryId">
          </app-error-display>
        </mat-form-field>
        <mat-checkbox
          color="primary"
          [attr.options-id]="'requireScanOut'"
          formControlName="requireScanOut">
          Students Must Scan Out
        </mat-checkbox>
        <mat-checkbox
          color="primary"
          [attr.options-id]="'allowMultipleEntries'"
          formControlName="allowMultipleEntries">
          Allow Multiple Entries
        </mat-checkbox>
        <mat-checkbox
          color="primary"
          [attr.options-id]="'openToAll'"
          formControlName="openToAll">
          Open To All
        </mat-checkbox>
        <mat-checkbox
          *ngIf="id"
          color="primary"
          [attr.options-id]="'active'"
          formControlName="active">
          Active
        </mat-checkbox>
      </mat-card-content>

      </mat-card>

    </div>
    <div class="column">
      <mat-card>
        <mat-card-header>
          <mat-card-title>EVENT TIME AND RECURRENCE</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-form-field class="full-width-input">
            <mat-label>Event Recurrence</mat-label>
            <input type="text" matInput formControlName="recurrence" [matAutocomplete]="autoRecurrence">
            <mat-icon matSuffix class="icon" *ngIf="!heroEventForm.get('recurrence').value">arrow_drop_down</mat-icon>
            <button
              matSuffix
              class="icon"
              *ngIf="heroEventForm.get('recurrence').value"
              mat-icon-button
              aria-label="Clear"
              (click)="onClear('recurrence')"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete #autoRecurrence="matAutocomplete" [displayWith]="displaySelectedRecurrence.bind(this)" showPanel="true">
              <mat-option *ngFor="let option of filteredRecurrenceOptions | async" [value]="option.value">
                {{option.display}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <div *ngIf="heroEventForm.controls['recurrence'].value === HeroEventRecurrenceEnum.WEEKLY || heroEventForm.controls['recurrence'].value === HeroEventRecurrenceEnum.MONTHLY">
            <mat-form-field class="full-width-input">
              <mat-label>Days when event can happen</mat-label>
              <mat-select formControlName="recurrenceScheduledDays" multiple>
                <mat-option
                  *ngFor="let day of dayOptions"
                  [value]="day.value">
                  {{day.display}}
                </mat-option>
              </mat-select>
              <app-error-display
                [form]="heroEventForm"
                controlName="recurrenceScheduledDays"></app-error-display>
            </mat-form-field>
          </div>
          <div *ngIf=" heroEventForm.controls['recurrence'].value === HeroEventRecurrenceEnum.MONTHLY">
            <mat-form-field class="full-width-input">
              <mat-label>Week of event</mat-label>
              <mat-select formControlName="monthlyRecurrence" multiple>
                <mat-option
                  *ngFor="let monthOption of monthlyRecurrenceOptions"
                  [value]="monthOption.value">
                  {{monthOption.display}}
                </mat-option>
              </mat-select>
              <app-error-display
                [form]="heroEventForm"
                controlName="monthlyRecurrence"></app-error-display>
            </mat-form-field>
          </div>
          <div class="form-row" *ngIf="heroEventForm.controls['recurrence'].value === HeroEventRecurrenceEnum.DAILY">
            <mat-slide-toggle formControlName="skipWeekends">
              Skip Weekends
            </mat-slide-toggle>
          </div>
          <mat-form-field class="full-width-input">
            <mat-label>Start Date</mat-label>
            <input
              matInput
              [matDatepicker]="startDatePicker"
              type="text"
              formControlName="startDate"
               />
            <mat-datepicker-toggle
              matSuffix
              [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field *ngIf="!heroEventForm.controls['recurrence'].value === HeroEventRecurrenceEnum.DAILY" class="full-width-input">
            <mat-label>End Date</mat-label>
            <input
              matInput
              [matDatepicker]="endDatePicker"
              type="text"
              formControlName="endDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
          </mat-form-field>

          <div class="form-row">
            <mat-form-field class="full-width-input">
              <mat-label>Start Time</mat-label>
              <input
                matInput
                type="time"
                formControlName="startTime"
                [value]="heroEventForm.controls.startTime.value"
                (change)="handleTimeChange($event)"
              />
            </mat-form-field>
            <mat-form-field class="filter-item">
              <mat-label>Duration (hours)</mat-label>
              <input
                matInput
                type="number"
                min="0"
                formControlName="duration"
              />
              <app-error-display
                [form]="heroEventForm"
                controlName="duration"></app-error-display>
            </mat-form-field>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</form>
<ng-container *ngIf="this.students && !this.heroEventForm.controls['openToAll'].value">
  <app-hero-event-create-edit-student-table
    [students]="students"
    (removeStudent)="removeStudent($event)"
    (showAddStudentModal)="showAddStudentModal()"
    (showBulkStudentProfileUploadModal)="showBulkStudentProfileUploadModal()"
    ></app-hero-event-create-edit-student-table>
</ng-container>
